import { VisibleWidgetsList } from './elements/VisibleWidgetsList'

export const VisibleWidgets = () => {
  return <VisibleWidgetsList />
}
